export const getUserDrawsOfficial = state => state.eventProfile.drawOfficials;
export const getUserCurrentDraws = state => state.eventProfile.currentDraw;
export const getAllDraws = state => state.eventProfile.draws;
export const getUserDrawsPlayers = state => state.eventProfile.players;
export const getMatchSheets = state => state.eventProfile.matchSheet;
export const getLocations = state => state.eventProfile.locations;
export const getTeams = state => state.eventProfile.teams;
export const getMatchSheetDataSelector = state => state.eventProfile.matchSheetData;
export const getDrawAllStatsSelector = state => state.eventProfile.drawAllStats;
export const getMedalPrintDataSelector = state => state.eventProfile.medalPrintData;

export const getIsLoadingDraws = state => state.eventProfile.currentDraw.loading && state.eventProfile.drawOfficials.loading && state.eventProfile.players.loading;
export const getIsMatchSheetDataLoading = state => state.eventProfile.matchSheetData.loading;
export const getIsDrawAllStatsLoading = state => state.eventProfile.drawAllStats.loading;
export const getIsMedalPrintDataLoading = state => state.eventProfile.medalPrintData.loading;
export const getCurrentMemberRegistration = state => state.eventProfile.currentMemberRegistration;
export const getIsCurrentMemberRegistrationLoading = state => state.eventProfile.currentMemberRegistration.loading;
